import { Outlet } from 'react-router';
import type { Route } from './+types/error';
import { GenericErrorBoundary } from './components/organisms/GenericErrorBoundary';

/**
 * The "default" ErrorBoundary for all routes under this layout. This is placed
 * immediately after `root.tsx` which ensures the error UI renders within the
 * app’s shared providers (MUI/theme, Emotion, etc.).
 *
 * You can add your own ErrorBoundary to your dynamic segment routes to display
 * the ErrorBoundary in a different layout.
 *
 * Do not place the `MainLayout` here since the UI won't be visible if an error
 * occurs.
 *
 * This route is configured in `routes.ts` as a Layout.
 */
export const ErrorBoundary = ({ error }: Route.ErrorBoundaryProps) => <GenericErrorBoundary error={error} />;

export const PageOutlet = () => <Outlet />;
